<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="7">
                        <v-card-title class="titulopagina">REPORTE RESUMEN DE INSPECCIONES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            :items="years"
                            v-model="year"
                            label="Seleccione Año"
                            dense
                            @change="cargarDatos"
                        ></v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-btn @click="excel" :disabled="dis_excel">Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <modal-ayuda></modal-ayuda>
        </v-card>
        <v-row class="ml-1 mr-1 mt-2">
            <h3>Observaciones Mensuales</h3>
        </v-row>
        <v-row class="ml-1 mr-1 mt-2" justify="center">
            <v-col cols="4">
                <v-simple-table
                    class="elevation-1"
                >
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center" v-for="item in monthHeaders" :key="item.name">{{ item.text }}</th>
                                <th class="text-center" v-for="causa in causas" :key="causa.causa">{{ causa.causa }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="item in monthItems">
                                <tr v-bind:key="item.index">
                                    <td>{{ item.month.text }}</td>
                                    <td class="text-right" v-for="(causa, index) in causas" :key="causa.index">
                                        {{ item['porc_'+index] }} %
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
            <v-col cols="8">
                <GChart
                    type="ColumnChart"
                    :data="chartData1"
                    :options="chartOptions1"
                    class="elevation-1 mb-2"
                />
                <GChart
                    type="ColumnChart"
                    :data="chartData2"
                    :options="chartOptions2"
                    class="elevation-1 mb-2"
                />
                <GChart
                    type="ColumnChart"
                    :data="chartData3"
                    :options="chartOptions3"
                    class="elevation-1 mb-2"
                />
            </v-col>
        </v-row>
        <v-row class="ml-1 mr-1 mt-2">
            <h3>Observaciones Semestrales</h3>
        </v-row>
        <v-row class="ml-1 mr-1 mt-2" justify="center">
            <v-col cols="4">
                <v-simple-table
                    class="elevation-1"
                >
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center" v-for="item in semestreHeaders" :key="item.name">{{ item.text }}</th>
                                <th class="text-center" v-for="s in semestres" :key="s.id">{{ s }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(causa, index) in causas">
                                <tr v-bind:key="causa.id">
                                    <td>{{ causa.causa }}</td>
                                    <td class="text-right" v-for="item in semestreItems" :key="item.index">
                                        {{ item['porc_'+index] }} %
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
            <v-col cols="8">
                <GChart
                    type="ColumnChart"
                    :data="chartData4"
                    :options="chartOptions4"
                    class="elevation-1 mb-2"
                />
                <GChart
                    type="ColumnChart"
                    :data="chartData5"
                    :options="chartOptions5"
                    class="elevation-1 mb-2"
                />
                
            </v-col>
        </v-row>
        <v-row class="ml-1 mr-1 mt-2">
            <h3>Observaciones por Sector</h3>
        </v-row>
        <v-row class="ml-1 mr-1 mt-2" justify="center">
            <v-col cols="12">
                <v-simple-table
                    class="elevation-1"
                >
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center">Causa</th>
                                <th class="text-center" v-for="s in sectores" :key="s.id">{{ s.nombre }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item) in areaItems">
                                <tr v-bind:key="item.id">
                                    <td>{{ item.causa }}</td>
                                    <td class="text-right" v-for="(s, index) in sectores" :key="s.id">
                                        {{ item['s'+index] }} %
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
            <v-col cols="12">
                <GChart
                    type="ColumnChart"
                    :data="chartData6"
                    :options="chartOptions6"
                    class="elevation-1 mb-2"
                />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        year: 2020,
        years: [],
        causas: [],
        url_excel: '',
        sectores: [],
        semestres: ['Semestre I', 'Semestre II'],
        porc_sectores: [],
        dis_excel: true,
        monthHeaders: [
            {
                text:'Mes',
                align:'center',
                sortable:true,
                filterable:true,
                value:'month.text'
            }
        ],
        monthItems: [],
        semestreHeaders: [
            {
                text:'Causa',
                align:'center',
                sortable:true,
                filterable:true,
                value:'causa.causa'
            }
        ],
        semestreItems: [],
        areaHeaders: [
            {
                text:'Causa',
                align:'center',
                sortable:true,
                filterable:true,
                value:'causa'
            }
        ],
        areaItems: [],
        chartData1: [],
        chartData2: [],
        chartData3: [],
        chartData4: [],
        chartData5: [],
        chartData6: [],
        chartOptions1: {
            title: 'Observaciones inspecciones - Semestre I',
            subtitle: 'Año 2021',
            isStacked: true,
            legend: {position: 'bottom'},
            seriesType: 'bars',
            series: {4: {targetAxisIndex: 1, type: 'line'}},
            vAxis: { minValue: 0, maxValue: 100, format: '#\'%\''}
        },
        chartOptions2: {
            title: 'Observaciones inspecciones - Semestre II',
            subtitle: 'Año 2021',
            isStacked: true,
            legend: {position: 'bottom'},
            seriesType: 'bars',
            series: {4: {targetAxisIndex: 1, type: 'line'}},
            vAxis: { minValue: 0, maxValue: 100, format: '#\'%\''}
        },
        chartOptions3: {
            title: 'Observaciones inspecciones - ANUAL',
            subtitle: 'Año 2021',
            isStacked: true,
            legend: {position: 'bottom'},
            seriesType: 'bars',
            series: {4: {targetAxisIndex: 1, type: 'line'}},
            vAxis: { minValue: 0, maxValue: 100, format: '#\'%\''}
        },
        chartOptions4: {
            title: 'No conformidades observaciones inspecciones - Semestre I',
            subtitle: 'Año 2021',
            legend: {position: 'bottom'},
            vAxis: { minValue: 0, maxValue: 100, format: '#\'%\''}
        },
        chartOptions5: {
            title: 'No conformidades observaciones inspecciones - Semestre II',
            subtitle: 'Año 2021',
            legend: {position: 'bottom'},
            vAxis: { minValue: 0, maxValue: 100, format: '#\'%\''}
        },
        chartOptions6: {
            title: 'No conformidades por Sector - Anual',
            subtitle: 'Año 2021',
            legend: {position: 'bottom'},
            height: 500,
            isStacked: true,
            seriesType: 'bars',
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 0},
                2: {targetAxisIndex: 0},
                3: {targetAxisIndex: 0},
                4: {targetAxisIndex: 1, type: 'line'}
            },
            vAxis: { minValue: 0, maxValue: 100, format: '#\'%\''},
            vAxes: {
                0: {title: 'Causa / Sector'},
                1: {title: 'Sector / Año'}
            }
        },
        cargaInicial: {
            sectores: false,
            causas: false,
            dashboard: false,
        },
        tituloLoadingInicial: '',
    }),
    mounted(){
        this.year = parseInt(this.moment().format("YYYY"));
        for(let y = 2020; y <= this.year; y++){
            this.years.push(y);
        }
        this.tituloLoadingInicial = 'Cargando Sectores, Causas, Dashboard...';
        this.mostrarLoading({
            titulo: this.tituloLoadingInicial,
            color: 'green',
        });
        Promise.all([
            this.cargarSectores(),
            this.cargarCausas(),
            this.cargarDatos(),
        ]).then(res => {
            this.ocultarLoading();
        })
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte Resumen de Inspecciones`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un reporte resumido de todas las inspecciones realizadas en el año indicado.`},
                {   tipo:`label`,   texto:`- Se muestra, de forma resumida, las observaciones agrupadas de forma mensual, semestral y por sector en distintas tablas para cada grupo`},
                {   tipo:`label`,   texto:`- Además, por cada tabla, se muestra un gráfico que indica de forma visual los datos existentes en las tablas`},
                {   tipo:`label`,   texto:`- Toda esta información se puede exportar en un excel pulsando el botón "Excel" que se encuentra arriba a la derecha de la pantalla`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarSectores(){
            //this.mostrarLoading('Cargando Sectores...');
            //this.mostrarLoading({titulo:'Cargando Sectores...',color:'green'})
            this.cargaInicial.sectores = true;

            let url = `${this.base_url}pac_sector_inspeccion`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.tituloLoadingInicial = this.tituloLoadingInicial.replace('Sectores, ', '');
                this.mostrarLoading({
                    titulo: this.tituloLoadingInicial,
                    color: 'green'
                });
                this.sectores = response.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarCausas(){
            this.causas = [];
            //this.mostrarLoading('Cargando Causas...');
            //this.mostrarLoading({titulo:'Cargando Causas..',color:'green'})
            this.cargaInicial.causas = true;

            let url = `${this.base_url}pac_causa`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.tituloLoadingInicial = this.tituloLoadingInicial.replace('Causas, ', '');
                this.mostrarLoading({
                    titulo: this.tituloLoadingInicial,
                    color: 'green'
                });
                this.causas = response.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarDatos(){
            this.dis_excel = true
            //this.mostrarLoading('Cargando Dashboard...');
            const cargaInicialRealizada = this.tituloLoadingInicial.includes('Dashboard');
            if(this.cargaInicial.dashboard) {
                this.mostrarLoading({titulo:'Cargando Dashboard...',color:'green'})
            } else {
                this.cargaInicial.dashboard = true;
            }

            let url = `${this.base_url}dashboard_inspeccion/${this.year}`;
            await this.axios.get(url, this.headers).then((response)=>{
                if(!cargaInicialRealizada) {
                    this.tituloLoadingInicial = this.tituloLoadingInicial.replace('Dashboard', '');
                    this.mostrarLoading({
                        titulo: this.tituloLoadingInicial,
                        color: 'green'
                    });
                } else {
                    this.ocultarLoading();
                }

                this.monthItems = response.data.mensual;
                this.semestreItems = response.data.semestral;
                this.areaItems = response.data.por_area;
                this.porc_sectores = response.data.porc_sectores;
                this.url_excel = response.data.url_excel;
                this.crearGraficos();
                this.dis_excel = false
            }).catch((error)=>{
                if(cargaInicialRealizada) this.ocultarLoading();
                this.errorMessage('Ha ocurrido un error al cargar gráficos');
                console.log('error',error);
                this.dis_excel = false
            });
        },
        async download(item){
            let url = `${this.base_url}imprimir_excel/${item.inspeccion_id}`;
            await this.axios.get(url, this.headers).then((response) => {
                window.location.href = this.download_url.replace('bitacoras', 'inspecciones/imagenes') + response.data;
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        crearGraficos(){
            //inicializa series
            this.chartData1 = [['Mes']];
            this.chartData2 = [['Mes']];
            this.chartData3 = [['Mes']];
            this.chartData4 = [['Causa']];
            this.chartData5 = [['Causa']];
            this.chartData6 = [['Causa']];
            this.dibujarSeries();
            this.dibujarDatos();
        },
        dibujarSeries(){
            this.causas.forEach (c => {
                this.chartData1[0].push(c.causa);
                this.chartData2[0].push(c.causa);
                this.chartData3[0].push(c.causa);
                this.chartData6[0].push(c.causa);
            });
            this.chartData4[0].push(this.semestres[0]);
            this.chartData5[0].push(this.semestres[1]);
            this.chartData1[0].push('% Mensual Semestre');
            this.chartData2[0].push('% Mensual Semestre');
            this.chartData3[0].push('% Anual');
            this.chartData6[0].push('% Total Sector');
        },
        dibujarDatos(){
            this.monthItems.forEach(item => {
                let row1 = [item.month.abrev];
                let row2 = [item.month.abrev];
                this.causas.forEach (function(c, i) {
                    row1.push(item['porc_'+i]);
                    row2.push(item['porc_'+i]);
                });
                if(item.month.numero <= 6){
                    row1.push(item.sem1);
                    this.chartData1.push(row1);
                }else{
                    row1.push(item.sem2);
                    this.chartData2.push(row1);
                }
                row2.push(item.year);
                this.chartData3.push(row2);
            });
            let semestres = this.semestreItems;
            this.causas.forEach((causa, i) => {
                let row1 = [causa.causa, semestres[0]['porc_'+i]];
                this.chartData4.push(row1);
                let row2 = [causa.causa, semestres[1]['porc_'+i]];
                this.chartData5.push(row2);
            });
            this.sectores.forEach ((s, i) => {
                let row = [s.nombre];
                this.causas.forEach((c, j) => {
                    row.push(this.areaItems[j]['s'+i]);
                });
                let porc = this.porc_sectores[i];
                row.push(porc);
                this.chartData6.push(row);
            });
        },
        async excel(){
            //await this.axios.get(`${this.base_url}dashboard_a_excel/${this.year}`, this.headers).then((res)=>{
                window.location.href = this.download_url.replace('bitacoras', 'inspeccion_pac') + 'graficos_'+this.year+'.xlsx';
            //}).catch((e) => {
            //    console.log(e);
           // })
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed: {
        ...mapState(['user', 'base_url', 'headers', 'download_url']),
    },
    components:{
        'modal-ayuda': ModalAyudas,
    }
}
</script>